// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { isEmpty } from "lodash";

export default styled(Drawer)(({ theme, ownerState, modalactive }) => {
  const { boxShadows, functions, transitions } = theme;
  const { openRequestor } = ownerState;

  const requestorWidth = '100%';
  const { lg } = boxShadows;
  const { pxToRem } = functions;

  // drawer styles when openRequestor={true}
  const drawerOpenStyles = () => ({
    width: requestorWidth,
    left: "initial",
    right: 0,
    transition: transitions.create("right", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.short,
    }),
  });

  // drawer styles when openRequestor={false}
  const drawerCloseStyles = () => ({
    left: "initial",
    right: pxToRem(-350),
    transition: transitions.create("all", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.short,
    }),
  });

  return {
    "& .MuiDrawer-paper": {
      height: "100vh",
      margin: 0,
      padding: `0 ${pxToRem(10)}`,
      borderRadius: 0,
      boxShadow: lg,
      overflowY: isEmpty(modalactive) ? "auto" : "auto",
      ...(openRequestor ? drawerOpenStyles() : drawerCloseStyles()),
    },
  };
});
